<video
  #videoElement
  class="own-video"
  (click)="playVideoWithoutControls(videoElement)"
  (pause)="onPause()"
  (play)="onPlay()"
  [ngStyle]="{
      'object-fit': objectFit,
      'object-position': objectPosition
    }"
  [controls]="false"
  [src]="source"
  [attr.aria-label]="ariaLabel || null"
  [loop]="loop"
  [lazyPoster]="poster"
  [muted]="muted"
  [autoplay]="autoPlay"
  [attr.webkit-playsinline]="true"
  [attr.x5-playsinline]="true"
  [attr.x5-video-player-type]="'h5'"
  [attr.x5-video-player-fullscreen]="false"
  playsinline
>
  <source [src]="source" />
</video>

<div
  *ngIf="controls"
  class="custom-video-controls"
  [ngClass]="{ 'mosaic-style': hudsonStyle === 'mosaic', 'profile-style': hudsonStyle === 'profile' }">
  <button
    class="play-pause-btn"
    (click)="togglePlayPause(videoElement, $event)"
    [attr.aria-label]="isPlaying ? 'Pause video' : 'Play video'">
    <svg
      *ngIf="isPlaying && !videoElement?.ended"
      height="18"
      viewBox="0 0 12 18"
      fill="none">
        <rect
          x="1"
          y="1.31006"
          height="15.3798"
          rx="1.5"
          [attr.stroke]="hudsonStyle === 'mosaic' ? 'white' : 'black'"
          stroke-linejoin="round"/>
        <rect
          x="8"
          y="1.31006"
          height="15.3798"
          rx="1.5"
          [attr.stroke]="hudsonStyle === 'mosaic' ? 'white' : 'black'"
          stroke-linejoin="round"/>
    </svg>

    <svg
      *ngIf="!isPlaying || videoElement?.ended"
      height="16"
      viewBox="0 0 15 16"
      fill="none">
        <path
          d="M14 7.53406C14.3331 7.72654 14.3331 8.20681 14 8.39929L2 15.328C1.66667 15.5204 1.25 15.2793 1.25 14.8944L1.25 1.03894C1.25 0.678172 1.61614 0.443542 1.93652 0.574096L2 0.605346L14 7.53406Z"
          [attr.stroke]="hudsonStyle === 'mosaic' ? 'white' : 'black'"/>
    </svg>
  </button>
</div>
